import { Eye, Building2, Shield, LucideIcon } from 'lucide-react'

export type AccessLevel = 'demo' | 'company' | 'admin'

interface AccessLevelConfig {
  label: string
  icon: LucideIcon
  color: string
  description: string
}

const accessLevelConfig: Record<AccessLevel, AccessLevelConfig> = {
  demo: {
    label: 'Demo',
    icon: Eye,
    color: 'bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/20 hover:bg-blue-500/20',
    description: 'Available to all users including demo accounts'
  },
  company: {
    label: 'Company',
    icon: Building2,
    color: 'bg-purple-500/10 text-purple-700 dark:text-purple-400 border-purple-500/20 hover:bg-purple-500/20',
    description: 'Restricted to company users and admins'
  },
  admin: {
    label: 'Admin',
    icon: Shield,
    color: 'bg-orange-500/10 text-orange-700 dark:text-orange-400 border-orange-500/20 hover:bg-orange-500/20',
    description: 'Restricted to administrators only'
  }
}

interface AccessLevelBadgeProps {
  accessLevel: AccessLevel
  position?: 'top-right' | 'top-left'
}

export function AccessLevelBadge({ accessLevel, position = 'top-right' }: AccessLevelBadgeProps) {
  const config = accessLevelConfig[accessLevel] || accessLevelConfig.demo
  const AccessIcon = config.icon

  const positionClasses = {
    'top-right': 'top-2 right-2',
    'top-left': 'top-2 left-2'
  }

  return (
    <div
      className={`
        absolute ${positionClasses[position]}
        ${config.color}
        border backdrop-blur-sm
        px-2 py-1 rounded-md
        text-xs font-medium
        flex items-center gap-1
        transition-colors duration-200
        cursor-help
      `}
      title={`${config.label} Access: ${config.description}`}
    >
      <AccessIcon className="w-3 h-3" />
      <span>{config.label}</span>
    </div>
  )
}
